module.exports = __webpack_public_path__ + "img/01—02—Network Topology > Circular.0af608e8.jpg";